import React from 'react';
import { CircularProgress, Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ButtonProps extends Omit<MuiButtonProps, 'sx'> {
  variant: 'contained' | 'outlined';
  width?: string;
  sx?: MuiButtonProps['sx'];
  isLoading?: boolean;
}

const StyledButton = styled(MuiButton)<{ width?: string }>(({ width }: { width?: string }) => ({
  height: '31px',
  borderRadius: '8px',
  textTransform: 'none',
  width: width || '100px',
  '&.MuiButton-contained': {
    color: '#FFFFFF',
    backgroundColor: '#702DFF',
    '&:hover': {
      backgroundColor: '#5725C0',
    },
    '&:disabled': {
      backgroundColor: '#D4C0FF',
    },
  },
  '&.MuiButton-outlined': {
    color: '#702DFF',
    borderColor: 'rgba(112, 45, 255, 1)',
    '&:hover': {
      borderColor: 'rgba(87, 37, 192, 1)',
      backgroundColor: '#F1F3FF',
    },
    '&:disabled': {
      color: '#D4C0FF',
      backgroundColor: 'rgba(241, 243, 255, 1)',
      borderColor: '#D4C0FF',
    },
  },
}));

const Button: React.FC<ButtonProps> = ({
  children,
  variant,
  width = 'auto',
  sx,
  isLoading,
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      width={width}
      sx={sx}
      {...props}
      disabled={isLoading || props.disabled}
      startIcon={isLoading ? <CircularProgress size={15} sx={{ color: '#fff' }} /> : props.startIcon}
    >
      {children}
    </StyledButton>
  );
};

export default Button; 